import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../AuthContext.jsx'

const PROPERTY_ID = import.meta.env.VITE_TAWK_PROPERTY_ID
const WIDGET_ID = import.meta.env.VITE_TAWK_WIDGET_ID

export default function TawkWidget() {
  const { user } = useAuth()
  const scriptRef = useRef(null)
  const [cookieConsent, setCookieConsent] = useState(
    () => localStorage.getItem('cookie_consent')
  )

  useEffect(() => {
    function handleConsentChange() {
      setCookieConsent(localStorage.getItem('cookie_consent'))
    }
    window.addEventListener('growlab:consentChanged', handleConsentChange)
    return () => window.removeEventListener('growlab:consentChanged', handleConsentChange)
  }, [])

  useEffect(() => {
    if (!user) {
      // Hide widget and remove script when logged out
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
        window.Tawk_API.hideWidget()
      }
      if (scriptRef.current) {
        scriptRef.current.remove()
        scriptRef.current = null
        window.Tawk_API = undefined
        window.Tawk_LoadStart = undefined
      }
      return
    }

    // Block Tawk.to if cookies not accepted
    if (cookieConsent !== 'accepted') return

    // Already loaded
    if (scriptRef.current) {
      return
    }

    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_LoadStart = new Date()

    window.Tawk_API.onLoad = function () {
      window.Tawk_API.setAttributes(
        { name: user.full_name || user.name || '', email: user.email || '' },
        function (error) { if (error) console.error('Tawk setAttributes error:', error) }
      )
      window.Tawk_API.hideWidget()

      window.Tawk_API.onChatMessageOperator = function () {
        window.Tawk_API.hideWidget()
        window.dispatchEvent(new CustomEvent('growlab:tawkUnread'))
      }
      window.Tawk_API.onChatMaximized = function () {
        window.dispatchEvent(new CustomEvent('growlab:tawkRead'))
      }
    }

    const script = document.createElement('script')
    script.async = true
    script.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')
    document.head.appendChild(script)
    scriptRef.current = script
  }, [user, cookieConsent])

  return null
}
